import React, { useState } from "react";
import PropTypes from "kf-proptypes/widgets";

import { BaseDropdown, BASE_DROPDOWN_POSITION } from "./base.jsx";
import {
  DropdownTarget,
  DROPDOWNTARGET_TYPE,
  DROPDOWNTARGET_SIZE
} from "../dropdowntarget/index.jsx";

/**
 * Dual Dropdown is a component used for 2 purpose while clicking the left part it beahviour different and while clicking right side icon it behaviour different, left side if user click it render date picket and right side if user click it show relative date value as dropdown
 */

export function DualDropDown(props) {
  const {
    listRendererOnLabel,
    listRendererOnArrow,
    labelRenderer,
    type = DROPDOWNTARGET_TYPE.MORE,
    getContainer = () => document.body,
    size = DROPDOWNTARGET_SIZE.MEDIUM_DEPRECATED,
    className
  } = props;
  const [openTrigger, setOpenTrigger] = useState("label");
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <BaseDropdown
        position={
          openTrigger === "label"
            ? BASE_DROPDOWN_POSITION.BOTTOM_LEFT
            : BASE_DROPDOWN_POSITION.BOTTOM_RIGHT
        }
        onOpen={() => setIsOpen(true)}
        onClose={() => setIsOpen(false)}
        getContainer={getContainer}
        targetRenderer={() => (
          <DropdownTarget
            isOpen={isOpen}
            className={className}
            size={size}
            type={type}
            onArrowClick={() => setOpenTrigger("arrow")}
            onLabelClick={() => setOpenTrigger("label")}
          >
            {labelRenderer && labelRenderer()}
          </DropdownTarget>
        )}
        listRenderer={
          openTrigger === "label" ? listRendererOnLabel : listRendererOnArrow
        }
      />
    </div>
  );
}

DualDropDown.propTypes = {
  /**
   * Left side render if user click left part
   */
  listRendererOnLabel: PropTypes.node,
  /**
   * Right side render if user click right side icon
   */
  listRendererOnArrow: PropTypes.node,
  /**
   * Dropdown Target label custom render
   */
  labelRenderer: PropTypes.func,
  /**
   * Container where the dropdown should trigger
   */
  getContainer: PropTypes.func,
  /**
   * To customise the style of the component
   */
  className: PropTypes.string,
  /**
   * Size of the dual dropdown can vary via this prop
   */
  size: PropTypes.string,
  /**
   * Type of the dual dropdown can vary via this prop
   */
  type: PropTypes.string
};

DualDropDown.defaultProps = {
  type: DROPDOWNTARGET_TYPE.MORE,
  getContainer: () => document.body,
  size: DROPDOWNTARGET_SIZE.MEDIUM_DEPRECATED
};
